var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cart-popup__dialog" },
    [
      _c("TripleEyeHeader"),
      _vm._v(" "),
      _c("div", { staticClass: "cart-popup__content height-auto" }, [
        _c("div", { staticClass: "content_eyecare" }, [
          _c(
            "div",
            [
              _vm._m(0),
              _vm._v(" "),
              _c("p", { staticClass: "eyecare_txt2" }, [
                _vm._v(
                  "12가지 질문에 대한 응답으로 확인된 안구건조증 결과를 확인해주세요."
                )
              ]),
              _vm._v(" "),
              _vm.score < 10
                ? [_vm._m(1), _vm._v(" "), _vm._m(2)]
                : _vm.score < 20
                ? [_vm._m(3), _vm._v(" "), _vm._m(4)]
                : _vm.score < 60
                ? [_vm._m(5), _vm._v(" "), _vm._m(6)]
                : _vm.score >= 60
                ? [_vm._m(7), _vm._v(" "), _vm._m(8)]
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                color: "#ccc",
                "font-size": "9px",
                "text-align": "right"
              }
            },
            [_vm._v("CN001953")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cart-popup__item-link" }, [
        _c(
          "button",
          {
            staticClass: "bt-akl-blue bt-eyecare-pop-sky",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.$emit("clickResult")
              }
            }
          },
          [_vm._v("이벤트 응모하기")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "eyecare_tit" }, [
      _c("b", { staticClass: "color_orange" }, [
        _vm._v("2. 나의 안구건조증 정도는?")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "txtC marB padT" }, [
      _c("img", {
        staticStyle: { "max-width": "320px", width: "100%" },
        attrs: {
          src:
            "https://www.amway.co.kr/_ui/responsive/theme-blue/images/eyecare/07_vis_01.png",
          alt: "의사가 눈에 대해서 말하는 그림"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "eyecare_result color_black" }, [
      _vm._v("\n          건강하게 관리되고 있습니다."),
      _c("br"),
      _vm._v(
        "\n          꾸준한 EPA DHA 섭취, 수분 보충, 적정 실내\n          습도(60%) 및 온도(18℃) 유지를 통해\n          앞으로도 건강하게 케어해주세요.\n        "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "txtC marB padT" }, [
      _c("img", {
        staticStyle: { "max-width": "320px", width: "100%" },
        attrs: {
          src:
            "https://www.amway.co.kr/_ui/responsive/theme-blue/images/eyecare/07_vis_02.png",
          alt: "의사가 EPA, DNA, 습도, 수분, 온도 등에 대해 말하는 그림"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "eyecare_result color_black" }, [
      _vm._v("\n          눈의 건조감이 약하게 나타나고 있습니다."),
      _c("br"),
      _vm._v(
        "\n          EPA DHA 보충, 수분 보충, 적정 실내 습도(60%) 및 온도(18℃) 유지 등에 신경 써주세요.\n        "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "txtC marB padT" }, [
      _c("img", {
        staticStyle: { "max-width": "320px", width: "100%" },
        attrs: {
          src:
            "https://www.amway.co.kr/_ui/responsive/theme-blue/images/eyecare/07_vis_02.png",
          alt: "의사가 EPA, DNA, 습도, 수분, 온도 등에 대해 말하는 그림"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "eyecare_result color_black" }, [
      _vm._v(
        "\n          눈이 많이 건조한 편으로, 적극적인 케어가 필요합니다."
      ),
      _c("br"),
      _vm._v(
        "\n          EPA DHA 보충, 수분 보충, 적정 실내 습도(60%) 및 온도(18℃) 유지 등에 신경 써주세요.\n        "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "txtC marB padT" }, [
      _c("img", {
        staticStyle: { "max-width": "320px", width: "100%" },
        attrs: {
          src:
            "https://www.amway.co.kr/_ui/responsive/theme-blue/images/eyecare/07_vis_03.png",
          alt:
            "의사가 병원 진료, EPA, DNA, 습도, 수분, 온도 등에 대해 말하는 그림"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "eyecare_result color_black" }, [
      _vm._v("\n          심한 건조감으로 병원 진료가 반드시 필요합니다."),
      _c("br"),
      _vm._v(
        "\n          더불어 EPA DHA 보충, 수분 보충, 적정 실내 습도(60%) 및 온도(18℃) 유지 등에 신경 써주세요.\n        "
      )
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-50f0e47c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50f0e47c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/triple-eye-care/component/result.vue
// module id = null
// module chunks = 